import { render, staticRenderFns } from "./share-link-modal.vue?vue&type=template&id=23deb73a&scoped=true"
import script from "./share-link-modal.vue?vue&type=script&lang=js"
export * from "./share-link-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23deb73a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23deb73a')) {
      api.createRecord('23deb73a', component.options)
    } else {
      api.reload('23deb73a', component.options)
    }
    module.hot.accept("./share-link-modal.vue?vue&type=template&id=23deb73a&scoped=true", function () {
      api.rerender('23deb73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/video-screen-recording/share-link-modal.vue"
export default component.exports